import { fromJS, Map } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import requestStatus from '../../constants/requestStatus';


const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null,
    loaded: false,
});


const onRequest = (state, action)   => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')
                                            .set('loaded', false)

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)
                                            .set('loaded', false)


const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .set('error', '')
                                            .set('loaded', true)

const loadAllReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        case actionTypes.LOAD_ALL_DATA_REQUEST:
            return onRequest(state, action);
        case actionTypes.LOAD_ALL_DATA_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.LOAD_ALL_DATA_ERROR:
            return onError(state, action);
        default:
            return state
    }}

export default loadAllReducer